module.exports = __webpack_public_path__ + "static/img/icon_info.38b34d8e.svg";